export const isNil = value => value === undefined || value === null
export const notNil = value => !isNil(value)

export const whenNil = (value, defaultValue) => (isNil(value) ? defaultValue : value)
export const whenNotNil = (value, defaultValue) => (notNil(value) ? value : defaultValue)
